import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/nik4o/Desktop/New Ver Web/iliqta/app/components/navbar/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/Users/nik4o/Desktop/New Ver Web/iliqta/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/nik4o/Desktop/New Ver Web/iliqta/app/NavbarToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/Users/nik4o/Desktop/New Ver Web/iliqta/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/Users/nik4o/Desktop/New Ver Web/iliqta/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"intera\"}");
